import React from 'react';
import CommunicationAssignmentList from './communicationAssignmentList';
import RouteMenu from 'mrf/view/MenuRoute';

export default function CommunicationAssignment({ match }) {
    return (
        <RouteMenu match={match} indexComponent={CommunicationAssignmentList}>
        </RouteMenu>
    );
}